import { render, staticRenderFns } from "./SocialConnectionsCard.vue?vue&type=template&id=a07b7650&scoped=true"
import script from "./SocialConnectionsCard.vue?vue&type=script&lang=js"
export * from "./SocialConnectionsCard.vue?vue&type=script&lang=js"
import style0 from "./SocialConnectionsCard.vue?vue&type=style&index=0&id=a07b7650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07b7650",
  null
  
)

export default component.exports